import { reactive } from 'vue';

export const criarProdutoMapa = () => {
  return reactive({
    id: 0,
    idep: 0,
    nmcategoria: '',
    nmproduto: '',
    unidade: '',
    ativo: 'S',
    ckcadastrado: 'S',
    ckresiduo: 'N',
    tpproduto: 'C',
    idlogin: 0
  });
}